import universalImport from 'babel-plugin-universal-import/universalImport';
import universal from 'react-universal-component';
import path from 'path';
import LazyComponent from './LazyComponent';

const importResource = universalImport({
    chunkName: () => 'LazyPromoSMSChunks',
    path: () => path.join(__dirname, './PromoSMSConnect'),
    resolve: () => require.resolveWeak('./PromoSMSConnect'),
    load: () =>
        Promise.all([
            import(/* webpackChunkName: "LazyPromoSMSChunks" */ './PromoSMSConnect'), // css name
        ]).then((proms) => proms[0]),
});

export default universal(importResource, LazyComponent.loaderResource);
